export default __webpack_public_path__ + "static/media/320x180.8dba5036.jpg";